module.exports = __webpack_public_path__ + "img/FantasyFighterCard.png";